import React from 'react';
import { Fab, Tooltip, Badge } from '@mui/material';
import { Lightbulb as LightbulbIcon } from '@mui/icons-material';

const ChatbotButton = ({ onClick, hasNewMessage = false, onError }) => {
  const handleClick = () => {
    try {
      if (onClick) onClick();
    } catch (error) {
      console.error('Erreur bouton chatbot:', error);
      if (onError) onError();
    }
  };

  return (
    <Tooltip 
      title="Assistant IA ECOTIJ" 
      placement="left"
      arrow
    >
      <Badge
        badgeContent={hasNewMessage ? '!' : 0}
        color="error"
        overlap="circular"
        sx={{
          position: 'fixed',
          bottom: { xs: 16, md: 20 },
          right: { xs: 16, md: 20 },
          zIndex: 9999,
          '& .MuiBadge-badge': {
            animation: 'pulse 2s infinite',
            '@keyframes pulse': {
              '0%, 100%': { transform: 'scale(1)' },
              '50%': { transform: 'scale(1.1)' },
            },
          },
        }}
      >
        <Fab
          color="primary"
          aria-label="assistant chatbot"
          onClick={handleClick}
          sx={{
            width: { xs: 56, md: 64 },
            height: { xs: 56, md: 64 },
            background: 'linear-gradient(135deg, #0077B8 0%, #00ACEA 100%)',
            boxShadow: '0 4px 20px rgba(0, 119, 184, 0.4)',
            '&:hover': {
              background: 'linear-gradient(135deg, #00ACEA 0%, #0077B8 100%)',
              transform: 'scale(1.08)',
              boxShadow: '0 6px 28px rgba(0, 119, 184, 0.5)',
            },
            transition: 'all 0.3s ease',
          }}
        >
          <LightbulbIcon sx={{ fontSize: { xs: 28, md: 32 }, color: '#F5A000' }} />
        </Fab>
      </Badge>
    </Tooltip>
  );
};

export default ChatbotButton;
